import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import itTranslations from './locales/it.json';
import esTranslations from './locales/es.json';
import deTranslations from './locales/de.json';
import nlTranslations from './locales/nl.json';
import filTranslations from './locales/fil.json';

const resources = {
  en: { translation: enTranslations },
  fr: { translation: frTranslations },
  it: { translation: itTranslations },
  es: { translation: esTranslations },
  de: { translation: deTranslations },
  nl: { translation: nlTranslations },
  fil: { translation: filTranslations },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Additional configuration
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (lng, ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation: ${key} for language: ${lng}`);
      }
    },
  });

export default i18n;
